import Component from 'gia/Component'
import stage from '../components/stage'
import renderer from '../components/render'
import _each from 'lodash.foreach'
import gsap from 'gsap'

import Textroll from './textroll'


class Footer extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.speed = 2
    this.isPlaying = false

    this.ref = {
      track: null,
      elm: null,
      work: null
    }
  }

  mount() {
    //  console.log("Mount Text!");

    this.isPlaying = false
    this.roll = new Textroll(this.element, this.ref)
    this.roll.mount()
    this.resizeQue = this.resize.bind(this)
    stage.on("stage:resize", this.resizeQue);
    this.renderQue = this.render.bind(this)
    stage.on("stage:scroll", this.renderQue);

    this.iswork = this.el.data('work') == true

    this.resize(stage)

    this.iswork && this.play()

      //this.play()

  }

  resize(e){
    this.main = $('.wrapper').height();
    this.render(e);
  }

  render(e){


      if(e.scrolltop + e.h/2 >= this.main - e.h/5)  {
        !this.isPlaying && this.play()
      }
      else {
        this.isPlaying && this.stop()
      }



  }


  stop(){
    this.roll.stop()
    this.isPlaying = false
  //  console.log("stop");
  }

  play(){
    this.roll.play()
    this.isPlaying = true
  //  console.log("play");
  }


  unmount() {
    this.roll.unmount()
  //  console.log("Unmount Text!");
  }


}

module.exports = Footer
